






































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";

import Validate from '@/mixins/validate';
import VaidateCondition from '@/mixins/validateCondition';

import getUrlParam from '@/common/utils/getUrlParam';
import { resolveBoundaryValue } from '@/common/utils/format';
import { Ladder } from '@/common/interface/group_type';
import { Tip } from "@/common/interface";
import { majorNoticeText } from '@/common/constants/index';
import Tips from "@/components/common/index/Tips.vue";
import Modal from "@/components/common/index/Modal.vue";
import DashLine from "@/components/common/edit/DashLine.vue";

const validateCondition = VaidateCondition();
const confirmContent = `<p>您当前设置为“拼团价”支付模式，若需添加多阶拼团方案，请改为“定金”支付模式</p>`
const ladderGroupTips = {
  title: '拼团方案',
  content: ` <p>1、拼团模式最多可设置5组价格梯度，成团人数越多，则对应拼团价越低</p>
          <p>2、多阶拼团模式下，若需开启支付功能，则仅支持“定金”支付，不支持“拼团价”支付</p>`
}

@Component({
  components: {
    tips: Tips,
    "dash-line": DashLine,
  }
})
export default class GroupLadder extends Vue{
  @Getter("ladderGroupList") ladderGroupList!: Ladder[];
  @Getter("canPay")  canPay!: boolean;
  @Getter("payType") payType!: string;
  @Getter("section") section: any;
  @Getter("xcxFlag") xcxFlag!: boolean;
  @Getter("xmMajordomo") xmMajordomo!: string;
  @Getter("xcxType") xcxType!: string;

  @Action("changePayType") changePayType!: Function;
  @Action("changeLadderGroup") changeLadderGroup!: Function;
  @Action("changeSectionInfo") changeSectionInfo!: Function;
  
  ladderGroupTips: Tip = ladderGroupTips;
  getUrlParam: Function = getUrlParam;

  get disabled() {
    return this.getUrlParam('type') === 'reEdit';
  }

  handleAddLadder() {
    if (this.xcxType === "mkb") {
      return;
    }
    // 普通用户不支持
    if (this.xcxFlag && !this.xmMajordomo) {
      Vue.$confirm({
        oneBtn: true,
        title: "提示",
        text: majorNoticeText,
        okText: "确定"
      });
      return;
    }
    // 再编辑状态不可点击
    if (this.disabled) return;
    // 判断是否开启了“拼团价”模式
    if(this.canPay && this.payType === '拼团价') {
      Vue.$confirm({
        okText: '定金支付',
        classname: 'text-align-left',
        text: confirmContent,
        ok: this.handleChangePayType
      });
    } else {
      // 新增一个拼团方案
      this.ladderGroupList.push({
        groupSize: '',
        groupPrice: ''
      });
      this.changeLadderGroup(this.ladderGroupList);
    }
  }

  // 删除拼团方案
  handleDeleteLadder(index: number) {
    this.ladderGroupList.splice(index, 1);
    this.changeLadderGroup(this.ladderGroupList);
  }

  // 改为定金模式
  handleChangePayType() {
    // 新增一个拼团方案
    this.ladderGroupList.push({
      groupSize: '',
      groupPrice: ''
    });
    this.changeLadderGroup(this.ladderGroupList);
    // 修改支付模式为定金，定金金额为空
    this.changePayType({ payType: '定金' });
  }

  handleInputBlur(value: number, type: string, decimal: boolean = false, index: number = 0) {
    const _value = resolveBoundaryValue(value, decimal);
    if (type === 'originPrice') {
      this.changeSectionInfo({ type, value: _value });
    }

    if (['groupSize', 'groupPrice'].includes(type)) {
      this.ladderGroupList[index][type] = _value;
      this.changeLadderGroup(this.ladderGroupList);
    }
  }

}
